import { useEffect, useState } from "react";
import { Listing, Place } from "./types";
import placeSearch from "./locations/place";

function useGooglePlaceSearch({
  address,
  displayName,
}: Pick<Listing, "address" | "displayName">) {
  const [place, setPlace] = useState<Place>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let fullAddress;
    if (address) {
      const { addressLine1, addressLine2, addressLine3, suburb } = address;
      fullAddress = [
        displayName,
        addressLine1,
        addressLine2,
        addressLine3,
        suburb,
      ]
        .filter((e) => e && e != "")
        .join(" ");
    } else {
      fullAddress = `${displayName}`;
    }

    placeSearch(fullAddress)
      .then((place) => {
        setPlace(place);
      })
      .finally(() => setIsLoading(false));
  }, [address]);

  return { place, isLoading };
}

export default useGooglePlaceSearch;
